import React, { useEffect } from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import { getLocale, getMbmOptions, getTimeZone } from '../helpers';
import { BadasGuidedPath } from "@amzn/badasui-components-react";
import homepage_pic from 'src/images/homepage_pic.png';
import {logger} from "src/logger";
import * as KatalMetrics from "@amzn/katal-metrics";
import initialMetricsPublisher from "src/metrics";

const mbmOptions = getMbmOptions(arbManifest);

const App = () => {
    const initializationMetric = new KatalMetrics.Metric.Initialization().withMonitor();
    const initializationMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForInitialization();

    let locale = getLocale();
    let timeZone = getTimeZone();

    useEffect(() => {
        const element = document.querySelector('badas-guided-path');

        const handleIsLoaded = () => {
            initializationMetric.setSuccess();
            initializationMetricsPublisher.publish(initializationMetric);
        };

        element?.addEventListener('isLoaded', handleIsLoaded as EventListener);

        const script = document.createElement('script');
        script.src = "https://46a392476265.us-east-1.captcha-sdk.awswaf.com/46a392476265/jsapi.js";
        script.async = true;
        document.head.appendChild(script);

        return () => {
            element?.removeEventListener('isLoaded', handleIsLoaded as EventListener);
        };
    }, []);

    logger.info(`Initializing BADAS Seller Central app with Locale: ${locale} and Time Zone: ${timeZone}`);

    return (
        <MbmProvider {...mbmOptions}>
            <BadasGuidedPath
                locale={locale}
                timezone={timeZone}
                metricsPublisher={initialMetricsPublisher}
                logger={logger}
                imageSrc={homepage_pic}
                apiCaptchaKey={"N4387ZM3Z1GiFH7fM6F0zuiwA4VkAcRzWJgK9+VrsXvdNSew1NKWeBPcVupEU2KlBypFcFlnwxhjmszUh8qtMTJjGozS/YJE08T7FRGst6YKet6xLB/2Uy/4xOxzMi1FkzoeMSs+vJ2oUosUNZYkzIhK/7eR8sC28F53BA21OiqdHf9lAWwk32xdp7idUJAm8c3UT6DSpwRqkISWcxJWjn8bz60kXagTLkME+5MzA2VLW0x4uVzTBSrFMCip67N4Vi1mCsdtACIyzh53dYiixmNiq+N+3hrE2HAh/R9afmnKUijFrstkFmyFRKYeILIDIIwlz7tnTe/SOrK61x6+qMQfD66PGA6ihEjzxYIfZd9Sgpkv2SBBwSprA3zIEqXOehv8mkeqBkBAq4uH0Ln5ys7k4N3MSvctZZU0OkIscl3yupDirVv79W8AqQ0rf2mZIqK1L+onBPWi8ORUxD7wac1ZkfdSpuVGJ2k2+wpTwijoVhex8WWqOGRDu0ExqlHE3t2ToLWWKxRgSB/mfaSvPLwMXGpHMyFMhC6Q55vP/9rYvDEHnXEUmpoJxyK8uxJkOQgi38penyEUB/A2bAEtygodwi+ylXk/mOBLASly9IYhAgmcXDrluHECipnlg6uUKOTI4riudDd6M/v3x9xb/4c/GoPthwSVc+ETmB1lXC8=_0_1"}
            />
        </MbmProvider>
    );
};

export default App;
